import { useState } from 'react';
import styled from 'styled-components';
import { apiLogin } from 'src/apis/utils/login';
import { useNavigate } from 'react-router-dom';
import { parkingFestivalList } from 'src/assets/database/parkingData';

export interface ILoginForm {
  loginId: string;
  password: string;
}

export default function Login({ festivalId }: { festivalId: number }) {
  const navigate = useNavigate();
  const currentFestival = parkingFestivalList.find(
    f => f.festivlaId === festivalId,
  )?.data;

  const [loginForm, setLoginForm] = useState<ILoginForm>({
    loginId: '',
    password: '',
  });

  const onChangeForm = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLoginForm(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const onKeyLogin = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onClickLogin();
    }
  };

  const onClickLogin = async () => {
    try {
      const res = await apiLogin.postLogin(loginForm);
      const { token } = res.data;

      if (token) {
        sessionStorage.setItem('token', token); // ✅ 세션스토리지로 변경
        navigate('/parking/admin');
      } else {
        alert('로그인 실패: 토큰이 없습니다.');
      }
    } catch (err) {
      alert('아이디 또는 비밀번호를 확인해주세요.');
      console.error(err);
    }
  };

  return (
    <LoginContainer>
      <LoginHeader>
        {currentFestival?.admintitle || '주차장 로그인'}
      </LoginHeader>
      <LoginContent>
        <LoginTitle>주차장 관리 로그인</LoginTitle>
        <IdInput
          name="loginId"
          placeholder="아이디"
          onChange={onChangeForm}
          onKeyDown={onKeyLogin}
        />
        <PasswordInput
          name="password"
          type="password"
          placeholder="비밀번호"
          onChange={onChangeForm}
          onKeyDown={onKeyLogin}
        />
        <LoginButton type="button" onClick={onClickLogin}>
          로그인
        </LoginButton>
      </LoginContent>
      <CopyRight>{currentFestival?.subtitle || '페스티맵 제작'}</CopyRight>
    </LoginContainer>
  );
}

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  background: #fff;
  padding: 14px auto 16px;
`;

const LoginHeader = styled.div`
  margin-top: 14px;
  color: #111;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

const LoginContent = styled.div`
  margin: 114px auto 0;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const LoginTitle = styled.div`
  color: #111;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
  margin-bottom: 20px;
`;

const IdInput = styled.input`
  width: 300px;
  height: 52px;
  border: 1px solid #e5e5ec;
  background: #fff;
  color: #111;
  font-size: 16px;
  font-weight: 400;
  padding: 14px 16px;
  margin-bottom: 8px;
`;

const PasswordInput = styled.input`
  width: 300px;
  height: 52px;
  border: 1px solid #e5e5ec;
  background: #fff;
  color: #111;
  font-size: 16px;
  font-weight: 400;
  padding: 14px 16px;
  margin-bottom: 16px;
`;

const LoginButton = styled.button`
  width: 300px;
  height: 52px;
  background: #111;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
`;

const CopyRight = styled.div`
  color: #707070;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-top: auto;
  margin-bottom: 16px;
`;
